import { Component, OnInit, ViewChild } from "@angular/core";
import { UniStepperComponent } from "@universal-ui";
import { first, switchMap } from "rxjs";

import { Unsubscriber } from "@shared/Components/Unsubscriber/unsubscriber.component";

import { TrustService } from "../Shared/Services/trust.service";

import { RequestCreationFormService } from "./Services/request-creation-form.service";
import { DocumentFile } from "./Types/document-file";
import { CreationRequest } from "./Types/Interfaces/new-request-creation.interface";
import { RequestDetailsDocumentsService } from "@fiduciaria/Shared/Services/request-details-documents.service";
import { RequestFiles } from "@fiduciaria/Shared/Types/files/request-files.interface";
import { TrustRequest } from "@fiduciaria/Shared/Types/request.interface";

@Component({
  selector: "app-request-creation",
  templateUrl: "./request-creation.component.html",
})
export class RequestCreationComponent extends Unsubscriber implements OnInit {
  @ViewChild("stepper") private stepper: UniStepperComponent;
  public currentFilesList: DocumentFile[];
  public currentFilesUploaded: DocumentFile[];
  private requestFiles: RequestFiles;

  constructor(
    private readonly requestCreationFormService: RequestCreationFormService, 
    private readonly trustService: TrustService,
    private readonly requestDetailsDocumentsService: RequestDetailsDocumentsService) {
    super();
  }

  public ngOnInit(): void {
    this.anotherSubscription = this.requestCreationFormService.reset.subscribe(() => {
      this.stepper.reset();
    });

    this.currentFilesList = [];
    this.currentFilesUploaded = [];

    this.requestFiles = {
      request: {
        requestNumber: "",
        subCaseNumber: ""
      } as TrustRequest,
      user: null,
      files: [],
      comment: "Documentos del caso",
      observation: "Inicio del caso",
      continueCase: false,
      label: "request-creation"
    };
  }

  public setCurrentFilesUploaded(files: DocumentFile[]): void {
    this.currentFilesUploaded = files;
  }

  public setCurrentFilesList(files: DocumentFile[]): void {
    this.currentFilesList = files;
  }

  private appendCurrentFilesToRequestForm(request: CreationRequest): CreationRequest {
    const files = request.files.filter((x) => !this.currentFilesUploaded.some((y) => y.file === x.file));

    this.currentFilesUploaded.forEach((x) => {
      const newFile = Object.freeze({
        name: x.name,
        file: x.file,
        fileExtension: "",
      });
      files.push(newFile);
    });

    files.sort((a, b) => a.name.localeCompare(b.name));
    request.files = files;
    return request;
  }

  private clearCurrentFiles(): void {
    this.currentFilesList = [];
    this.currentFilesUploaded = [];
  }

  public onBack(): void {
    this.stepper.previous();
    this.clearCurrentFiles();
  }

  public uploadFilesToAzureStorage(requestNumber: string): void {
     this.requestFiles = {
        ...this.requestFiles,
        request: {
          requestNumber,
          subCaseNumber: (requestNumber)? `${requestNumber}-1` : ""
        }
      } as RequestFiles;

      this.requestDetailsDocumentsService.uploadFiles(this.requestFiles);
  }

  public onComplete(): void {
    this.requestCreationFormService.value.subscribe((request) => this.appendCurrentFilesToRequestForm(request));

    this.requestCreationFormService.value.subscribe((request) => {
      const files: File[] = [];
      for(let fileObject of request.files) {
        if(fileObject?.file?.object) files.push(fileObject.file.object);
      }

      if(files.length > 0) {
         this.requestFiles.files = this.requestDetailsDocumentsService.addFiles(files);
      }
    });

    this.anotherSubscription = this.requestCreationFormService.value
      .pipe(
        first(),
        switchMap((value) => {
          this.clearCurrentFiles();
          return this.trustService.createTrustRequest(value);
        })
      )
      .subscribe((response) => {
        this.requestCreationFormService.setResponse(response);
        this.stepper.next();
        this.clearCurrentFiles();
        this.uploadFilesToAzureStorage(response?.processRadNumber ?? "");
      });
  }
}
